import React, { Dispatch, SetStateAction } from 'react';
import {
  View, Text, StyleSheet, Pressable,
} from 'react-native';
import BinIcon from '../../../components/BinIcon';
import isMobile from '../../../components/IsMobile';
import Colors from '../../../constants/Colors';
import Style from '../../../constants/Style';
import { Ticket } from '../../../constants/Types';

interface TicketOptionsProps {
  moreOptionsVisible: boolean,
  setMoreOptionsVisible: Dispatch<SetStateAction<boolean>>,
  showAlert,
  selectedTicket: Ticket,
  deleteTicket,
}

const TicketOptions = ({
  moreOptionsVisible, setMoreOptionsVisible, showAlert, selectedTicket, deleteTicket,
}: TicketOptionsProps) => <View style={styles.container}>
    <Pressable
      style={(state) => [styles.item, state.pressed && Style.pressed]}
      onPress={() => {
        setMoreOptionsVisible(!moreOptionsVisible);
        showAlert(
          'Delete the Ticket',
          <Text numberOfLines={2}>
            Do you want to delete the ticket -{' '}
            <Text numberOfLines={1} style={Style.alertBoldText}>
              {` "${selectedTicket.name}"`}
            </Text>
            ?
          </Text>,
          true,
          deleteTicket,
          'Delete',
        );
      }}
    >
      <View style={styles.binIconContainer}>
        <BinIcon />
      </View>
      <Text style={styles.title}>Delete ticket</Text>
    </Pressable>
  </View>;

const styles = StyleSheet.create({
  container: {
    height: 36,
    width: 120,
    zIndex: 1,
    backgroundColor: '#fff',
    borderRadius: 8,
    overflow: 'hidden',
    position: 'absolute',
    right: 20,
    top: isMobile ? 105 : 50,
    elevation: 50,
  },
  item: {
    flex: 1,
    alignItems: 'center',
    flexDirection: 'row',
    zIndex: 1,
  },
  binIconContainer: {
    width: 32,
    alignItems: 'center',
  },
  title: {
    fontFamily: 'Roboto_500Medium',
    fontSize: 10,
    color: Colors.light.hereworksPrimaryGrey800,
  },
});

export default TicketOptions;
